import VT from '@/store/types';

export default {
  [VT.TRANSLATIONS_LIST]: (state, { data, status }) => {
    state.translationsList = { data, status };
  },
};
